import { AxiosError } from "axios";

export class ResponseError extends Error {
  status: number;
  statusText: string;
  data: unknown;

  constructor(error: AxiosError) {
    super();
    this.status = error.response.status;
    this.statusText = error.response.statusText;
    this.data = error.response.data;
  }
}
